import { useReducer } from "react";
import { IUpdatePolicyTerm } from "../../models/policy-term/request";
import EndPoints from "../../services/end-points";
import { execute } from "../../utils/helpers/execute";
import PolicyTermContext, { internalState } from "./context";
import reducer from "./reducer";
export interface IProps {
  children: React.ReactNode;
}
const PolicyTermContextProvider: React.FC<IProps> = (props) => {
  const [state, dispatch] = useReducer(reducer, internalState);
  const getPolicyTerm = async () => {
    await execute({
      callback: async () => {
        dispatch({ type: "LOADING", payload: { loading: "list" } });

        const { data } = await EndPoints.policyTerm.getPolicyTerm();

        dispatch({ type: "SET_LIST", payload: { list: data } });
      },
      fallback: (error) => {},
      finallyCallback: () => {
        dispatch({ type: "LOADING", payload: { loading: "list" } });
      },
      throwException: false,
    });
  };

  const updatePolicyTerm = async (request: IUpdatePolicyTerm) => {
    await execute({
      callback: async () => {
        dispatch({
          type: "LOADING",
          payload: { loading: "update" },
        });
        await EndPoints.policyTerm.updatePolicyTerm(request);
      },
      fallback: (error) => {},
      finallyCallback: () => {
        dispatch({
          type: "LOADING",
          payload: { loading: "update" },
        });
      },
      throwException: true,
    });
  };

  return (
    <PolicyTermContext.Provider
      value={{
        ...state,
        actions: {
          getPolicyTerm,
          updatePolicyTerm,
        },
      }}
    >
      {props.children}
    </PolicyTermContext.Provider>
  );
};

export default PolicyTermContextProvider;
